import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { PromotionFormData } from './promotion-form'

/**
 * Inline validation errors for a single rule or action row (#TAG-1512).
 *
 * Shared by rule-card and action-card. Returns a red-border flag plus a renderer that shows the
 * translated message (the schema emits i18n keys under `promotion.validation.*`) and gives the
 * message a DOM id matching the field path, so `PromotionForm`'s invalid-submit handler can scroll
 * the offending row into view.
 */
export const useRowFieldErrors = (section: 'rules' | 'actions', index: number) => {
    const { t } = useTranslation('stores')
    const { formState: { errors } } = useFormContext<PromotionFormData>()
    const rowErrors = errors?.[section]?.[index] as Record<string, { message?: string }> | undefined

    const hasFieldError = (field: string) => !!rowErrors?.[field]

    const renderFieldError = (field: string) => {
        const message = rowErrors?.[field]?.message
        if (!message) return null
        return (
            <p id={`${section}.${index}.${field}`} className="text-destructive mt-1 text-xs">
                {t(message)}
            </p>
        )
    }

    return { hasFieldError, renderFieldError }
}
